module.exports = __webpack_public_path__ + "static/img/cif-gt.453b2ac.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/svg/flag/cif-gt.svg
// module id = 6Zlp
// module chunks = 2